import { Input } from "antd"
import { AuthFormItem } from "components/atoms/form"
import React from "react"

export const FormPasswordInput = () => {
  return (
    <AuthFormItem
      label="パスワード"
      name="password"
      rules={[{ required: true, message: "パスワードを入力してください" }]}
    >
      <Input.Password />
    </AuthFormItem>
  )
}
